import {Injectable} from '@angular/core';

import {UserB} from './user-b';
import {HttpClient} from '@angular/common/http';
import {StorageUtils} from '../../../utils/storage-utils';
import {RestService} from '../../../utils/rest-service';
import {JsonContainer} from '../../../utils/json-container';
import {Role} from '../backoffice-role/role';
import {KeyAuth} from '../../ok-auth-key/key-auth';
import {UserBSearch} from './user-b-search';
import {FileUpload} from '../../ok-core/photo/file-upload';
import { Process } from 'app/pages/process/process/process';


@Injectable()
export class UserBService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'userBackoffice', storageUtils);
    }

    authenticate(userB: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePost('authenticate', userB, callback)
    }

    forgotPassword(userB: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePut('forgotPassword/' + userB.email, null, callback)
    }

    updatePasswordForgot(userB: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePost('updatePasswordForgot', userB, callback)
    }

    validateKey(keyAuth: KeyAuth, callback: (result: JsonContainer, userB: UserB) => void) {
        this.executePost('validateKey', keyAuth, callback)
    }

    menu(callback: (result: JsonContainer, roles: Role[]) => void) {
        this.executeGet('menu', callback)
    }

    searchAdmin(userBSearch: UserBSearch, callback: (result: JsonContainer, companyCards: UserB[]) => void) {
        this.executePost('searchAdmin', userBSearch, callback)
    }

    changeStatus(userB: UserB, callback: (result: JsonContainer, companyCards: UserB[]) => void) {
        this.executePost('changeStatus', userB, callback)
    }

    saveUserB(user: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePost('saveUser', user, callback)
    }

    saveInfo(user: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePost('saveInfo', user, callback)
    }

    loadUserB(id: string, callback: (result: JsonContainer, roles: UserB) => void) {
        this.executeGet('load/' + id, callback)
    }

    searchResponse(userbSearch: UserBSearch, callback: (result: JsonContainer, list: any) => void) {
        this.executePost('searchResponse', userbSearch, callback)
    }

    search(userbSearch: UserBSearch, callback: (result: JsonContainer, list: any) => void) {
        this.executePost('search', userbSearch, callback)
    }

    searchList(userbSearch: UserBSearch, callback: (result: JsonContainer, list: any) => void) {
        this.executePost('searchList', userbSearch, callback)
    }

    saveAvatar(fileUpload: FileUpload, callback: (result: JsonContainer, list: any) => void) {
        this.executePost('saveAvatar', fileUpload, callback)
    }

    autoLogin(userB: UserB, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePost('autoLogin', userB, callback)
    }

    userBSession(callback: (result: JsonContainer, roles: UserB) => void) {
        this.executeGet('userBSession', callback)
    }
    uploadFile(fileUpload: FileUpload, userId: string, type: string, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePut(`uploadAvatar/${userId}/${type}`, fileUpload, callback)
    }
    uploadDocuments(fileUpload: FileUpload, userId: string, processId: string, type: string, callback: (result: JsonContainer, user: UserB) => void) {
        this.executePut(`uploadDocuments/${userId}/${processId}/${type}`, fileUpload, callback)
    }
    update(userB: UserB, callback: (result: JsonContainer) => void) {
        this.executePut(`saveData`, userB, callback)
    }
    updateUserOpenCompany(userB: UserB, callback: (result: JsonContainer) => void) {
        this.executePut(`openCompanyData`, userB, callback)
    }
    updateUserOpenCompanyProcess(process: Process, callback: (result: JsonContainer) => void) {
        this.executePut(`openCompanyDataProcess`, process, callback)
    }
    loadByUser(userId: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet(`loadByUser/${userId}`, callback)
    }
    loadByName(name: string, callback: (result: JsonContainer, userB: UserB) => void) {
        this.executeGet(`loadByName/${name}`, callback)
    }
    countUsersByStatus(callback: (result: JsonContainer, data: any) => void): void {
        this.executeGet(`countUsersByStatus`, callback);
    }
}
